import { FC } from 'react'
import { Text } from '@blueprintjs/core'
import { ResponsiveBlock } from 'client/components/ResponsiveBlock/ResponsiveBlock'

import { ProductsBlock } from '../HomePageContent/components/ProductsBlock/ProductsBlock'

import { ProductBlock } from './components/ProductBlock/ProductBlock'
import { useTranslation } from 'react-i18next'
import { ClientLocaleNS } from 'lib/constants/locales'

type TProps = {}

const ProductPageContent: FC<TProps> = () => {
  const { t } = useTranslation(ClientLocaleNS.ProductPage)
  return (
    <div className="flex flex-1 flex-col">
      <ProductBlock />
      <ResponsiveBlock>
        <Text tagName="span" className="mb-4 font-body---20px text-palette-grey--50">
          {t('see_also')}
        </Text>
      </ResponsiveBlock>
      <ProductsBlock />
    </div>
  )
}

export { ProductPageContent }
